import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Row,
  Col,
  NavItem,
  NavLink
} from "reactstrap";
import Popover from "@material-ui/core/Popover";
import SmartphoneIcon from "@material-ui/icons/Smartphone";
import TabletMacIcon from "@material-ui/icons/TabletMac";
import DesktopWindowsIcon from "@material-ui/icons/DesktopWindows";
import { templateConstants } from "../../../../../constants/cms/template/template.constants";
import "./PreviewOption.css";
import { templateActions } from "../../../../../store/actions/cms/template/template.action";
import { labelHelper } from "../../../../../helpers/labelHelper";
import Zoom from '@material-ui/core/Zoom';
import { Tooltip } from '@material-ui/core';
const cDevices = [
  {
    name: "Desktop",
    id: templateConstants.DESKTOP,
    icon: (
      <DesktopWindowsIcon
        /*   style={{ fontSize: "18px" }} */
        className=" pop-list-icon"
      />
    )
  },
  {
    name: "Tablet",
    id: templateConstants.TABLET,
    icon: (
      <TabletMacIcon /* style={{ fontSize: "18px" }} */ className=" pop-list-icon" />
    )
  },
  {
    name: "SmartPhone",
    id: templateConstants.SMARTPHONE,
    icon: (
      <SmartphoneIcon /* fontSize={'small'} */ /* style={{ fontSize: "18px" }} */ className=" pop-list-icon" />
    )
  }
];

const PreviewOption = ({ device, dispatch }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const deviceIcon = (className, d, style = {}) => {
    switch (d) {
      case "desktop":
        return <DesktopWindowsIcon fontSize={'inherit'} style={style} className={className} />;
      case "tablet":
        return <TabletMacIcon fontSize={'inherit'} style={style} className={className} />;
      case "smartphone":
        return <SmartphoneIcon fontSize={'inherit'} style={style} className={className} />;
      default:
        return "";
    }
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const toggleDevice = device => {
    handleClose();
    dispatch(templateActions.togglePreviewMode(device));
  };
  const getDeviceOptions = () => {
    let devices = [];
    cDevices.map((d, index) => {
      devices.push(
        <Row key={index} style={{ margin: "0px" }}>
          <Col style={{ padding: "0px" }}>
            <NavLink
              className="list-option-device"
              active={d.id === device}
              onClick={() => toggleDevice(d.id)}
            >
              {deviceIcon("pop-list-icon slim", d.id)}
              {/*    <SystemLabel name={d.name} /> */}
            </NavLink>
          </Col>
        </Row>
      );
    });
    return devices;
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  return (
    <React.Fragment>
      <NavItem>
        <Tooltip TransitionComponent={Zoom} placement="top" title={labelHelper.getLabel("Devices")}>
          <NavLink className="nav-toolbar-item" onClick={handleClick}>
            {deviceIcon("editor-toolbar-icon", device, { fontSize: '18px !important', color: open ? '#fff' : 'inital', marginBottom: '2px' })}
          </NavLink>
        </Tooltip>
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          style={{ zIndex: 10000, padding: "10px" }}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center"
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center"
          }}
        >
          {getDeviceOptions().map(d => {
            return d;
          })}
        </Popover>
      </NavItem>
    </React.Fragment>
  );
};

function mapStateToProps(state) {
  return {
    device: state.template.previewDevice
  };
}
export default connect(mapStateToProps)(PreviewOption);
